import styled from 'styled-components';
import { LayoutBox } from '../Layout/LayoutBox';
export const TransitionCollapse = styled(LayoutBox).withConfig({
  displayName: "TransitionCollapse",
  componentId: "sc-1s0gm68-0"
})(["--transition-size:", ";block-size:var(--transition-size);overflow:clip;transition:block-size ", "ms ease-out;"], ({
  isVisible
}) => isVisible ? 'calc-size(auto, size)' : '0', ({
  transitionDuration = 300
}) => transitionDuration);